import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { T, MAX_PILLS } from "../../constants/todoTokens";
import TaskPill from "./TaskPill";

const DayCell = ({ date, tasks, current, isToday, isMobile, onTaskClick, onDayClick }) => {
  const shown    = tasks.slice(0, MAX_PILLS);
  const overflow = tasks.length - MAX_PILLS;
  const isWeekend = date.day() === 0 || date.day() === 6;

  return (
    <Box
      onClick={() => tasks.length > 0 && onDayClick(date)}
      sx={{
        minHeight: { xs: 70, sm: 90, md: 110 },
        borderRight:  `1px solid ${T.border}`,
        borderBottom: `1px solid ${T.border}`,
        bgcolor: isToday   ? "#F0FDFA"
               : !current  ? "#FAFBFC"
               : isWeekend ? "#FDFEFE"
               :              "#fff",
        p: { xs: "4px", sm: "6px" },
        cursor: tasks.length > 0 ? "pointer" : "default",
        transition: "background 0.15s",
        "&:hover": tasks.length > 0 ? { bgcolor: isToday ? "#CCFBF1" : "#F8FFFE" } : {},
        overflow: "hidden",
      }}
    >
      {/* Day number */}
      <Box sx={{ mb: "4px" }}>
        <Box
          sx={{
            width: { xs: 22, sm: 26 },
            height: { xs: 22, sm: 26 },
            borderRadius: "50%",
            display: "flex", alignItems: "center", justifyContent: "center",
            bgcolor: isToday ? T.primary : "transparent",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "11px", sm: "12px" },
              fontWeight: isToday ? 800 : current ? 600 : 400,
              color: isToday ? "#fff" : current ? T.text : T.textMuted,
              lineHeight: 1,
              userSelect: "none",
            }}
          >
            {date.date()}
          </Typography>
        </Box>
      </Box>

      {/* Task pills */}
      <Stack spacing="2px">
        {shown.map((task) => (
          <TaskPill key={task._id} task={task} onClick={onTaskClick} isMobile={isMobile} />
        ))}
      </Stack>

      {/* +N more */}
      {overflow > 0 && (
        <Typography
          onClick={(e) => { e.stopPropagation(); onDayClick(date); }}
          sx={{
            fontSize: { xs: "9px", sm: "10px" },
            fontWeight: 700, color: T.primary,
            mt: "3px", px: "4px",
            cursor: "pointer",
            "&:hover": { textDecoration: "underline" },
            userSelect: "none",
          }}
        >
          +{overflow} more
        </Typography>
      )}
    </Box>
  );
};

export default React.memo(DayCell);
